import {EventEmitter, Injectable} from '@angular/core';
import {
  IPlatformToolHandler
} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {PlatformCommand} from '@shared/commands/command-base';
import {DialogService} from '@shared/services/dialog-service';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformToolSpreadsheetHandler} from '@features/spreadsheet/services/platform-tool-spreadsheet-handler';
import {Api} from '@shared/constants/common-field.constants';
import { Subject } from 'rxjs';
import {FuseSplashScreenService} from '@barebone-fuse-services/splash-screen.service';
import {take} from 'rxjs/operators';
import {CommandService} from '@core/services/command.service';
import {Router} from '@angular/router';
import {SnackBarService} from '@core/services/snack-bar.service';


@Injectable({
  providedIn: 'root',
})
export class ExcelFormWarningGridHandler implements IPlatformToolHandler {

  invalidateSubject: InvalidateSubject;
  ngUnsubscribe = new Subject<void>();
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  constructor(
    private dialogService: DialogService,
    private platformToolSpreadsheetHandler: PlatformToolSpreadsheetHandler,
    private fuseSplashScreenService: FuseSplashScreenService,
    private commandService: CommandService,
    private router: Router,
    private snackBarService: SnackBarService
  ) {
    this.invalidateSubject = new InvalidateSubject();
  }

  executeCommand(command: PlatformCommand, handler: IPlatformToolHandler, callback?: any): boolean {
    this.executeCommandToApi(command);
    return true;
  }

  private executeCommandToApi(command: PlatformCommand) {
    if (command.api && command.api.length > 0 && !command.isDisabled) {
      this.fuseSplashScreenService.show();
      this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(commandResponse => {
          console.log('Command Response', commandResponse);
          this.fuseSplashScreenService.hide();

          if (commandResponse.fieldValues['RedirectCommand']) {
            this.executeCommandToApi(commandResponse.fieldValues['RedirectCommand']);
            return;
          }

          if (commandResponse.fieldValues['RedirectUrl']) {
            this.router.navigateByUrl(commandResponse.fieldValues['RedirectUrl']);
          } else if (commandResponse.fieldValues['SnackBarMessage']) {
            if (commandResponse.fieldValues['DeleteFlowTemplate']) {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            } else {
              const duration = commandResponse.fieldValues['SnackBarMessage'].length * 80;
              this.snackBarService.showInformation(commandResponse.fieldValues['SnackBarMessage'], duration);
            }
          } else if (commandResponse.fieldValues['Error']) {
            const duration = commandResponse.fieldValues['Error'].length * 80;
            this.snackBarService.showInformation(commandResponse.fieldValues['Error'], duration);
          }
        },

        error => {
          console.error('Failed ToolBarComponent command', error);
          this.fuseSplashScreenService.hide();
        }
      );
    }
  }


  valueChanged($event) {
    if ($event.action?.id === 'resolve-warning') {
      const workbookId = $event.item.cells['WorkbookId'].value;
      const worksheetId = $event.item.cells['WorksheetId'].value;

      const command = new PlatformCommand('SpreadsheetNavigationCommand', Api.Spreadsheet);
      command.setValue('LoadWorkbook', workbookId);
      command.setValue('LoadWorksheet', worksheetId);
      this.platformToolSpreadsheetHandler.executeCommand(command, null);
      this.dialogService.closeDialog({});
      return;
    }
  }

  destroy(): void {
    this.invalidateSubject.close();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  setSelectedTab(selectedTab: TabModel): void {
  }


}
